<template>
  <div class="address-list-container">
    <v-radio-group
      class="radio-group"
      hide-details
      :value="value"
      @change="handleChange"
    >
      <v-layout
        pa-3
        class="order-item"
        v-for="(item, index) in new_adressList"
        :key="index"
      >
        <v-layout row>
          <v-layout shrink v-if="isSelection">
            <v-radio :value="item.guid" />
          </v-layout>
          <v-layout column>
            <v-layout mb-2 align-center class="address-info">
              <v-flex class="default" shrink v-if="item.defaultAddress">
                {{ $t("address_list.default") }}
              </v-flex>
              <v-flex class="number" shrink>{{ item.contact }}</v-flex>
              <v-flex class="time" shrink>{{ item.phone }}</v-flex>
            </v-layout>
            <v-layout justify-center v-if="showDetail">
              <v-flex class="time">
                {{ item.country }}
                {{ item.province }}
                {{ item.city }}
                {{ item.address1 }}
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout column align-end justify-center grow shrink>
            <router-link
              class="menu-item"
              :to="{
                name: 'address/edit',
                params: { guid: item.guid },
                query: { editSuccessRedirectType: editSuccessRedirectType }
              }"
            >
              {{ $t("address.edit") }}
            </router-link>
          </v-layout>
        </v-layout>
      </v-layout>
      <v-flex mt-4>
        <button class="button shadow" @click="submit">
          {{ $t("address.create") }}
        </button>
      </v-flex>
    </v-radio-group>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import address from "@/api/address";
export default {
  props: {
    isSelection: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    },
    createSuccessRedirectType: {
      type: String,
      default: null
    },
    editSuccessRedirectType: {
      type: String,
      default: null
    },
    showDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      adress: [],
      adressList: [],
      new_adressList: []
    };
  },
  created() {
    if (this.isLogin) {
      // this.loadAddress();

      this.getdAddress();
      // this.adressList = this.addressList;
      // console.log('--------',this.addressList)
    } else {
      let adress = localStorage.getItem("addressList");
      if (adress != null) {
        this.adress.push(JSON.parse(adress));
        this.setAddressList(this.adress);
        this.new_adressList = this.adress;
      } else {
        this.new_adressList = [];
      }
    }
  },
  computed: {
    ...mapState(["addressList", "isLogin", "zipcode"])
  },
  methods: {
    ...mapActions(["loadAddress"]),
    ...mapMutations(["setAddressList", "setZipCode"]),
    submit() {
      const query = {};
      if (this.createSuccessRedirectType) {
        query.createSuccessRedirectType = this.createSuccessRedirectType;
      }

      this.$router.push({
        query,
        name: "address/create"
      });
    },
    async getdAddress() {
      try {
        const {
          data: { isError, data }
        } = await address.loadAddress();

        if (isError) {
          return;
        }
        console.log("测试数据", data);
        this.new_adressList = data;
      } catch (e) {
        console.log(e);
      }
    },
    handleChange(value) {
      this.$emit("input", value);
      this.$emit("change", value);
      for (var i = 0; i < this.new_adressList.length; i++) {
        // console.log('选择的值---',this.new_adressList[i])
        // console.log('选择的值',value,this.new_adressList[i].guid)
        if (value == this.new_adressList[i].guid) {
          this.setZipCode(this.new_adressList[i].zipcode);
          console.log("看下值", value == this.new_adressList[i].guid);
          console.log("------", this.zipcode);
        }
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./address-list.sass"></style>
